import ReferralFAQItem from './ReferralFAQItem';
import accordionData from '../../../data/referral.json';

const ReferralFAQ = () => {
  return (
    <section className="block" id="faq">
      <div className="fixed">
        <h3>Что надо знать</h3>
        {accordionData.map((v, i) => (
          <ReferralFAQItem {...v} key={i} />
        ))}
      </div>
    </section>
  );
};

export default ReferralFAQ;
